import { render, staticRenderFns } from "./Debit.vue?vue&type=template&id=5d5c2b75&"
import script from "./Debit.vue?vue&type=script&lang=js&"
export * from "./Debit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports